/**
 * Viewer (User) Dashboard Help Content
 *
 * Feature: 177 - Dashboard Polish & Collection Column Coverage (US1)
 * Page: /dashboard (Viewer / User role variant)
 * Constitution: v1.22.0 — Principle XXXVII (Code Header Standards)
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const viewerDashboardHelp: PageHelpContent = {
  pageTitle: 'Viewer Dashboard',
  purpose:
    'Your personal, read-only view of the Fabric Control Plane: recently accessed workspaces, notifications, and a feed of recent activity.',
  sections: [
    {
      title: 'What this view shows',
      paragraphs: [
        'The Viewer dashboard is read-only — it surfaces the information most relevant to you without any administrative controls. You can browse recent workspaces and activity, but configuration and operational actions are reserved for Operator and Admin roles.',
      ],
      concepts: [
        { term: 'Recent Workspaces', definition: 'Workspaces you have recently accessed, for quick navigation.' },
        { term: 'Notifications', definition: 'Recent notices such as backup completions and storage warnings relevant to you.' },
        { term: 'Recent Activity', definition: 'A chronological feed of recent platform events you have visibility into.' },
        { term: 'Read-only', definition: 'This role can view data but cannot change configuration, trigger jobs, or manage resources.' },
      ],
    },
    {
      title: 'Data Refresh',
      paragraphs: [
        'The view refreshes automatically (polling, ~30–60s). If something looks stale, navigate away and back to force a refresh.',
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Workspaces', href: '/workspaces' },
        { label: 'Documentation', href: '/help/docs' },
      ],
    },
  ],
};

export default viewerDashboardHelp;
